import { useState } from 'react';
import { BUTTON_TYPE } from '../../../../global/Button';
import { TbbCardBalanceSection, TbbSpendSection } from '../../../../global/RegisterTbb/RewardCouponScreen';
import RegistrationSuccess from '../../Components/Animations/RegistrationSuccess';
import CardSection from '../../Components/CardSection';
import GiftCardsSlider from '../../Components/GiftCardsSlider/GiftCardsSlider';
import ExclusiveRewardsCarousel from '../PostRegistration/ExclusiveRewardsCarousel';
import ExploreMoreRewards from '../PostRegistration/ExploreMoreRewards';
import ReadyToShip from '../PostRegistration/ReadyToShip';
import TbbRegisteredDialog from '../PostRegistration/TbbRegisteredDialog';
import useRedirectWithPostHog from '../../../../../../hooks/useRedirectWithPostHog';
import ProgressButton from '../../Components/ProgressButton';
import './ShippingAndRewards.scss';

const ShippingAndReward = ({
  storeConfig,
  onClick,
  shippingMethod,
  creditAmt,
  couponData,
  promoCreditAmount,
  address,
  showDialog,
  stepTrackerProps,
  redemptionCode,
  isTechRecycling,
}) => {
  const [showRegistrationSuccess, setShowRegistrationSuccess] = useState(showDialog);
  const [isOpenDialog, setIsOpenDialog] = useState(true);

  const { waitTimer, redirectToEarnings } = useRedirectWithPostHog(storeConfig);

  const showNoCouponMessage = (!couponData?.couponCode || couponData?.couponCode?.trim() === '')
    && storeConfig.registerTbbFlow?.rewardStep?.noCouponMessage;

  if (showRegistrationSuccess && storeConfig.isTrashie) {
    return (
      <RegistrationSuccess
        isTechRecycling={isTechRecycling}
        onShowingAnimation={setShowRegistrationSuccess}
      />
    );
  }

  return (
    <div className="ShippingAndReward">
      <div className="ShippingAndReward__container">
        <ReadyToShip
          onClick={onClick}
          shippingMethod={shippingMethod}
          address={address}
          stepTrackerProps={stepTrackerProps}
          storeConfig={storeConfig}
        />
        {(!storeConfig.isTrashie && !storeConfig.registerTbbFlow?.rewardStep?.hideCoupon) && (
          <CardSection
            title={showNoCouponMessage ? '' : 'Your exclusive reward'}
          >
            <div className="ShippingAndReward__container--coupon">
              {showNoCouponMessage ? (
                <div style={{ textAlign: 'center', padding: '1rem' }}>
                  {storeConfig.registerTbbFlow.rewardStep.noCouponMessage}
                </div>
              ) : (
                <>
                  {storeConfig.registerTbbFlow.rewardStep?.couponDescription && (
                    <div className="ShippingAndReward__container--coupon--description">
                      {storeConfig.registerTbbFlow.rewardStep.couponDescription}
                    </div>
                  )}
                  <TbbCardBalanceSection
                    storeConfig={storeConfig}
                    couponData={couponData}
                    couponCreditAmt={storeConfig?.registerTbbFlow?.rewardStep?.cashValue}
                  />
                </>
              )}
            </div>
          </CardSection>
        )}
        {storeConfig.registerTbbFlow?.rewardStep?.showExclusive && (
          <ExclusiveRewardsCarousel code={redemptionCode} />
        )}
        {storeConfig.registerTbbFlow?.rewardStep?.buyAtShop?.enabled && (
          <CardSection
            title={`Shop${storeConfig.title ? ` with ${storeConfig.title}` : ''}`}
          >
            <TbbSpendSection storeConfig={storeConfig} />
          </CardSection>
        )}
        {!storeConfig.registerTbbFlow?.rewardStep?.hideRewards && (
          <ExploreMoreRewards
            title="Use your TrashieCash™"
            storeConfig={storeConfig}
            buttonText="View All Rewards"
            buttonType={BUTTON_TYPE.QUINARY}
          />
        )}
        <div className="ShippingAndReward__container--giftcards">
          <GiftCardsSlider
            title={(
              <div className="ShippingAndReward__container--giftcards--title">
                Explore gift cards
              </div>
            )}
          />
        </div>
      </div>

      <ProgressButton
        onSubmit={() => redirectToEarnings(false)}
        storeConfig={storeConfig}
        stepTrackerProps={stepTrackerProps}
        counter={waitTimer}
        name="CONTINUE"
      />

      <TbbRegisteredDialog
        isOpen={isOpenDialog && showDialog && !storeConfig.isTrashie}
        onClose={() => setIsOpenDialog(false)}
        {...{
          recyclingProductType: isTechRecycling ? 'BOX' : 'BAG',
          storeConfig,
          creditAmt,
          promoCreditAmount,
          shippingMethodUid: shippingMethod.uid,
        }}
      />
    </div>
  );
};

export default ShippingAndReward;
